import AdminContactSearchSchool from '../../../components/admin/contacts/AdminContactSearchSchool';
import SelectField from '../../../components/forms/SelectField';
import { ALL_SELECT_OPTION } from '../../../constants/settings.constants';

const FirstTimeSchoolOptions = ({
  data,
  onChange,
  onNetChange,
  onSchoolChange,
  onBranchChange,
  isLoadingNets,
  nets = [],
  netsLoadError = '',
  isLoadingSchools,
  schools = [],
  schoolsLoadError = '',
  isLoadingBranches,
  branches = [],
  branchesLoadError = '',
  disabled
}) => {
  const handleSearchSelect = (selected) => {
    if (selected?.schoolId) {
      onNetChange([selected?.netId]);
      onSchoolChange([selected?.schoolId]);
      onBranchChange([ALL_SELECT_OPTION.value]);
      return;
    }

    if (selected?.netId) {
      onNetChange([selected?.netId]);
      onSchoolChange([ALL_SELECT_OPTION.value]);
      onBranchChange([ALL_SELECT_OPTION.value]);
      return;
    }
  };

  return (
    <div>
      <AdminContactSearchSchool onSelect={handleSearchSelect} />
      <SelectField
        className="u-margin-bottom u-margin-top"
        label="Schoolnet"
        required
        isSubmitting={isLoadingNets}
        options={nets}
        value={data?.nets}
        onChange={onNetChange}
        multiple
        hasError={!!netsLoadError}
        description={netsLoadError}
        disabled={disabled}
      />
      {data?.nets?.length > 0 && (
        <SelectField
          className="u-margin-bottom"
          label="School"
          required
          isSubmitting={isLoadingSchools}
          options={schools}
          value={data?.schools}
          multiple
          allOption
          onChange={onSchoolChange}
          hasError={!!schoolsLoadError}
          description={schoolsLoadError}
          disabled={disabled}
        />
      )}
      {data?.schools?.length > 0 && (
        <SelectField
          className="u-margin-bottom"
          label="Vestiging"
          required
          isSubmitting={isLoadingBranches}
          options={branches}
          multiple
          allOption
          value={data?.branches}
          onChange={(value) => onChange(value, 'branches')}
          hasError={!!branchesLoadError}
          description={branchesLoadError}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default FirstTimeSchoolOptions;
